// returns an array with the foreground/background effect blocks
export var generateAiEffectBlocks = function (workspace) {
    return [
        workspace.newBlock('Dancelab_setForegroundEffectExtended'),
        workspace.newBlock('Dancelab_setBackgroundEffectWithPaletteAI'),
    ];
};
